import { isDefined } from '@sgme/fp';

import type { BidAskPPS, BidAskRate } from '@/utils/number-point.ts';

type Parameters = {
  nearNotional: number;
  farNotional: number;
  pinnedNearPrice: BidAskRate | undefined;
  traderSpotPrice: BidAskRate;
  nearDeltaRate: BidAskRate;
  marginSpotPps: BidAskPPS;
  currencyPairPrecision: number;
};

// SpotPriceClientBid (Client Spot price)
// =SI(PinNearPriceClientBid<>""
//   ;NearPriceClientBid-NearPointsClientBid*10^-4
//   ;SpotPriceTraderBid-SIGNE(FarNotional-NearNotional)*SpotComMarginBid*10^-4)
//
// SpotPriceClientAsk
// =SI(PinNearPriceClientAsk<>""
//   ;NearPriceClientAsk-NearPointsClientAsk*10^-4
//   ;SpotPriceTraderAsk+SIGNE(FarNotional-NearNotional)*SpotComMarginAsk*10^-4)

export function computeSpot({
  nearNotional,
  farNotional,
  pinnedNearPrice,
  traderSpotPrice,
  nearDeltaRate,
  marginSpotPps,
  currencyPairPrecision,
}: Parameters): BidAskRate {
  if (isDefined(pinnedNearPrice)) {
    return {
      bid: pinnedNearPrice.bid - nearDeltaRate.bid,
      ask: pinnedNearPrice.ask - nearDeltaRate.ask,
    };
  }

  const unevenDirection = Math.sign(farNotional - nearNotional);
  return {
    bid: traderSpotPrice.bid - unevenDirection * marginSpotPps.bid * 10 ** -currencyPairPrecision,
    ask: traderSpotPrice.ask + unevenDirection * marginSpotPps.ask * 10 ** -currencyPairPrecision, // nota bene : + operation
  };
}
